import { HttpRequestEntity } from 'shared/domain/httpRequest/httpRequestModel';
import type { ProcessType } from 'shared/domain/process/types/model';
import { broadcastUpdatedProcess, broadcastProcessError } from 'serviceWorker/broadcasts/processes';
import { replaceCachedProcess } from 'serviceWorker/services/processes';
import { chooseErrorMessage } from 'shared/utils/errorHandling';
import { neverReached } from 'shared/utils/neverReached';

/** Answers a process change with its `uniqueId`, so the page's command resolves or rejects with it. */
export function broadcastProcessResponse(
  request: HttpRequestEntity,
  response: ProcessType | { error: unknown }
): void {
  const { uniqueId } = request.data;
  if ('error' in response && response.error) {
    return broadcastProcessError(response.error, uniqueId, chooseErrorMessage(response.error) ?? undefined);
  }

  switch (request.method) {
    case 'PUT': {
      const process = response as ProcessType;
      replaceCachedProcess(process);
      return broadcastUpdatedProcess(process, uniqueId);
    }
    case 'POST':
    case 'DELETE':
    case 'GET':
      return broadcastProcessError(
        new Error(`${request.method} method not supported for process`),
        uniqueId
      );
    default:
      neverReached(request.method);
  }
}
